<!-- Template -->

<template>
    <div >
        <Header/>

        <TopNavigation :path="path" :loading="loading" />

        <section id="main-container">
            <div class="bg container" v-if="bgVisible" ref="bg" :class="{ visible: bgVisible }" ></div>
            
            <div class="container" ref="container">
                <div class="row app">
                    <div v-if="!loading && !firstPage"><RequestSupportButton /> </div>
                    <span v-if="loading" class="spinner-border main-loader"></span>

                    <HospitalNavigation :active="hospital" :hospitals="hospitals"  v-if="!loading"/>   
                                     
                    <div v-if="hospital" class="col-11 pr-0">
                        <div class="tab-content">
                            <div class="tab-pane active">
                                <div class="row">
                                    
                                    <Sidebar :active="section"  :hospital="hospital" @contactDetailsAreChanged2="changeName($event)"/>
                                    
                                    <div v-if="$slots.default" class="col-9 main-column" ref="mainColumn">
                                        <div class="tab-content">
                                            <div class="tab-pane active">
                                                <slot/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <Footer/>
    </div>
</template>

<!-- Script -->

<script>
    import Header from "@/components/Header";
    import Footer from "@/components/Footer";
    import Sidebar from "@/components/Sidebar";
    import TopNavigation from "@/components/TopNavigation";
    import HospitalNavigation from "@/components/HospitalNavigation";
    import RequestSupportButton from '@/components/RequestSupportButton';

    export default {
        name: "DefaultLayout",

        components: {
            Header,
            Footer,
            Sidebar,
            TopNavigation,
            HospitalNavigation,
            RequestSupportButton
        },

        data() {
            return {
                bgVisible: true
            };
        },

        computed:{
            firstPage(){
                return this.$route.path === '/hospitals'
            }
        },

        props: ["path", "hospital", "hospitals", "section", "loading"],

        methods:{
            changeName(data){
                this.$emit('contactDetailsAreChanged3', data);
            }
        },

        created() {
            if(this.$route.name != 'Hospitals' && this.$route.name != 'Hospital'){
                this.bgVisible = false;
            }
        }
    };
</script>

